<template>
  <v-row>
    <v-col cols="12">
      <v-row>
        <v-col cols="12" sm="12" md="6" lg="2">
          <v-select
            outlined
            flat
            dense
            background-color="white"
            v-model="params.type"
            :items="listType"
            label="Type"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="3" v-if="params.type === 'DP AP'">
          <v-select
            outlined
            flat
            dense
            background-color="white"
            v-model="params.id"
            :items="accounts"
            item-text="accountName"
            item-value="accountId"
            label="Account"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="2">
          <v-menu
            v-model="menuDate"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                outlined
                flat
                dense
                background-color="white"
                v-model="params.date"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                label="Date"
              ></v-text-field>
            </template>
            <v-date-picker v-model="params.date" @input="menuDate = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="2">
          <v-btn color="primary" @click="search" class="mr-2">
            <v-icon>
              mdi-magnify
            </v-icon>
          </v-btn>
          <v-btn v-if="$rbac.can('report.export')" @click="excel" color="success">
            <v-icon>
              mdi-file-excel
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <reconciliation-ar
        :items="items"
        :type="params.type"
        v-if="params.type === 'AR'"
      ></reconciliation-ar>
      <reconciliation-ap
        :items="items"
        :type="params.type"
        v-if="params.type === 'AP'"
      ></reconciliation-ap>
      <reconciliation-dp-ar
        :detail="detail"
        :type="params.type"
        v-if="params.type === 'DP AR'"
      ></reconciliation-dp-ar>
      <reconciliation-dp-ap
        :detail="detail"
        :type="params.type"
        v-if="params.type === 'DP AP'"
      ></reconciliation-dp-ap>
      <reconciliation-inventory
        :items="items"
        :type="params.type"
        v-if="params.type === 'INVENTORY'"
      ></reconciliation-inventory>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import ReconciliationAr from "./ReconciliationAr.vue";
import ReconciliationAp from "./ReconciliationAp.vue";
import ReconciliationDpAr from "./ReconciliationDpAr.vue";
import ReconciliationDpAp from "./ReconciliationDpAp.vue";
import ReconciliationInventory from "./ReconciliationInventory.vue";
import fileDownload from "js-file-download";

export default {
  name: "report-reconciliation",
  components: {
    ReconciliationAr,
    ReconciliationAp,
    ReconciliationDpAr,
    ReconciliationDpAp,
    ReconciliationInventory,
  },
  data() {
    return {
      params: {
        type: "AR",
        date: moment().format("yyyy-MM-DD"),
        id: 0,
      },
      listType: ["AR", "AP", "DP AR", "DP AP", "INVENTORY"],
      menuDate: false,
      items: [],
      accounts: [],
      detail: {},
    };
  },
  methods: {
    async search() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("report/getReconciliation", this.params)
        .then(response => {
          if (this.params.type === "DP AR" || this.params.type === "DP AP") {
            this.detail = response.data;
          } else {
            this.items = response.data;
          }
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    async excel() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("report/getReconciliationExcel", this.params)
        .then(response => {
          fileDownload(response.data, `report-reconciliation-${this.params.type}.xlsx`);
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    async getAccounts() {
      const response = await this.$store.dispatch("chartOfAccount/getAccounts", true);
      if (response.status === 200) {
        const idsToFilter = [13, 14, 15, 185, 186, 187];
        this.accounts = response.data.filter(x => idsToFilter.includes(x.accountId));
      }
    },
  },
  mounted() {
    this.getAccounts();
  },
};
</script>

<style></style>
